/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_V3_Title1Inputs */

const en_svc_browser_extensions_v3_title1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest V3 builds`)
};

const ar_svc_browser_extensions_v3_title1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بناءات Manifest V3`)
};

const bn_svc_browser_extensions_v3_title1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest V3 বিল্ড`)
};

const de_svc_browser_extensions_v3_title1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest V3-Builds`)
};

const es_svc_browser_extensions_v3_title1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilaciones de manifiesto V3`)
};

const fr_svc_browser_extensions_v3_title1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versions du manifeste V3`)
};

const pt_svc_browser_extensions_v3_title1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilações do manifesto V3`)
};

const zh_svc_browser_extensions_v3_title1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清单 V3 版本`)
};

const tr_svc_browser_extensions_v3_title1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest V3 derlemeleri`)
};

const ru_svc_browser_extensions_v3_title1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сборки манифеста V3`)
};

const pl_svc_browser_extensions_v3_title1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompilacje manifestu w wersji 3`)
};

/**
* | output |
* | --- |
* | "Manifest V3 builds" |
*
* @param {Svc_Browser_Extensions_V3_Title1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_v3_title1 = /** @type {((inputs?: Svc_Browser_Extensions_V3_Title1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_V3_Title1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_v3_title1(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_v3_title1(inputs)
	if (locale === "de") return de_svc_browser_extensions_v3_title1(inputs)
	if (locale === "es") return es_svc_browser_extensions_v3_title1(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_v3_title1(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_v3_title1(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_v3_title1(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_v3_title1(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_v3_title1(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_v3_title1(inputs)
	return en_svc_browser_extensions_v3_title1(inputs)
});
export { svc_browser_extensions_v3_title1 as "svc_browser-extensions_V3_title" }